import { ref } from 'vue';

/**
 * A page-defined action icon rendered in the admin header (leading/left slot on mobile).
 * A page registers one in `onMounted` via `setHeaderAction`; the Admin shell clears it on
 * every route change, so pages never need to clear it themselves.
 */
export interface HeaderAction {
  icon: string;          // PrimeIcons class, e.g. 'pi-plus'
  onClick: () => void;
  ariaLabel?: string;
}

// Module-level singleton (same pattern as useDrawer) so the Admin shell and any page share it.
const headerAction = ref<HeaderAction | null>(null);

export function useHeaderAction() {
  const setHeaderAction = (action: HeaderAction) => {
    headerAction.value = action;
  };
  const clearHeaderAction = () => {
    headerAction.value = null;
  };
  return { headerAction, setHeaderAction, clearHeaderAction };
}
